import { LETTER_PARTY_THEME_KEYS, type LetterPartyTheme } from '@/features/letterParty/types';

import sandBottom from '@/features/letterParty/assets/images/sand-bottom.svg';
import sandcastle from '@/features/letterParty/assets/images/sandcastle.svg';
import sandLeft from '@/features/letterParty/assets/images/sand-left.svg';
import sandRight from '@/features/letterParty/assets/images/sand-right.svg';
import swimmingFloat from '@/features/letterParty/assets/images/swimmingfloat.svg';
import gull from '@/features/letterParty/assets/lottie/gull.json';
import palmTreeLevel1 from '@/features/letterParty/assets/lottie/palm-tree-level-1.json';
import palmTreeLevel4 from '@/features/letterParty/assets/lottie/palm-tree-level-4.json';
import speaker from '@/features/letterParty/assets/lottie/speaker.json';
import startSpeaker from '@/features/letterParty/assets/lottie/start-speaker.json';
import waves from '@/features/letterParty/assets/lottie/waves.json';

const beachTheme: LetterPartyTheme = {
	key: LETTER_PARTY_THEME_KEYS.BEACH,
	colors: {
		gameBackground: 0xd043f7,
	},
	images: {
		gameScreen: {
			decorations: {
				sandBottom,
				sandcastle,
				sandLeft,
				sandRight,
				swimmingFloat,
			},
		},
	},
	animations: {
		startScreen: {
			palmTree: palmTreeLevel1,
			speaker: startSpeaker,
		},
		gameScreen: {
			palmTree: palmTreeLevel1,
			speaker,
			waves,
		},
		endScreen: {
			gull,
			palmTree: {
				default: palmTreeLevel1,
				highScore: palmTreeLevel4,
			},
		},
	},
};

export default beachTheme;
